import { Button, ButtonComponentProps } from 'components/atoms/Button';
import useAIUsageConsent from 'hooks/shared/useAIUsageConsent';
import { FC } from 'react';
import { UserAiUsageConsentEnum } from 'types/users.types';

type AIConsentButtonProps = ButtonComponentProps & {
  requiredConsent: UserAiUsageConsentEnum;
  onUpdate: (...args: any[]) => any;
};

const AIConsentButton: FC<AIConsentButtonProps> = ({
  requiredConsent,
  onUpdate,
  ...props
}) => {
  const { patchConsent, isLoading } = useAIUsageConsent({ onUpdate });

  return (
    <Button
      structure="text"
      loading={isLoading}
      onClick={() => patchConsent(requiredConsent)}
      {...props}
    />
  );
};

export default AIConsentButton;
